<template>
  <div
    class="modal"
    id="projectmodal"
    tabindex="-1"
    role="dialog"
    aria-labelledby
    data-backdrop="static"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="hideModal()"
        >
          <i class="el-icon-close"></i>
        </button>
        <div class="modal-body">
          <p class="font18 text-center">
            {{ edit ? "EDIT PROJECT" : "CREATE A NEW PROJECT" }}
          </p>
          <div class="row">
            <div class="col-sm-8 col-sm-offset-2">
              <table class="table mt30 font12">
                <tr>
                  <td>Project name</td>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="project.name"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="text-middle">Customer name</td>
                  <td class="text-right">
                    <input
                      type="text"
                      class="form-control"
                      v-model="project.customer_name"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="text-middle">Category</td>
                  <td class="text-right">
                    <select class="form-control" v-model="project.category">
                      <option value="1">Residential</option>
                      <option value="2">Hospitality</option>
                      <option value="3">Marine</option>
                      <option value="4">Commercial</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td class="text-middle">Country</td>
                  <td class="text-right text-middle">
                    <input
                      type="text"
                      class="form-control"
                      v-model="project.country"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="text-middle">City</td>
                  <td class="text-right text-middle">
                    <input
                      type="text"
                      class="form-control"
                      v-model="project.city"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="text-middle">
                    Description
                    <br />
                    <span class="font10">(max 250 symbols)</span>
                  </td>
                  <td class="text-right text-middle">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 5 }"
                      v-model="project.description"
                      maxlength="250"
                      show-word-limit
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <td class="text-middle">Number of rooms</td>
                  <td class="text-right text-middle">
                    <el-input-number
                      class="w100"
                      size="medium"
                      v-model="project.num_room"
                      controls-position="right"
                      :min="1"
                    ></el-input-number>
                  </td>
                </tr>
                <tr>
                  <td class="text-middle">System</td>
                  <td class="text-right text-middle">
                    <select class="form-control" v-model="project.system">
                      <option
                        v-for="(system, index) of systems"
                        :value="system"
                        :key="index"
                      >
                        {{ system }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr v-if="project.category == 2">
                  <td class="text-middle">Hotel brand</td>
                  <td class="text-right text-middle">
                    <input
                      type="text"
                      class="form-control"
                      v-model="project.hotel_brand"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="text-middle">Purchase Order #</td>
                  <td class="text-right text-middle">
                    <input
                      type="text"
                      class="form-control"
                      v-model="project.order_num"
                    />
                  </td>
                </tr>
              </table>

              <div class="mt50 text-center">
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="el-button mr20"
                  @click="hideModal()"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="el-button el-button--primary"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="edit ? edit_project() : add_new_project()"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProjectForm",
  data() {
    return {
      edit: false,
      project: {
        name: "",
        customer_name: "",
        category: 1,
        country: "",
        city: "",
        description: "",
        num_room: "",
        hotel_brand: "",
        order_num: "",
      },
      systems: [
        "Crestron",
        "KNX",
        "Savant",
        "Control 4",
        "Lutron",
        "Philips Dynalight",
        "RTI",
        "Rako Controls",
        "Schneider Electric",
        "Others",
        "Demo"
      ],
    };
  },
  methods: {
    showModal(project) {
      if (project) {
        this.project = project;
        this.edit = true;
      }
      window.$("#projectmodal").modal("show");
    },
    hideModal() {
      this.resetProject();
      window.$("#projectmodal").modal("hide");
    },
    resetProject() {
      this.project = {
        name: "",
        customer_name: "",
        category: 1,
        country: "",
        city: "",
        description: "",
        num_room: "",
        hotel_brand: "",
        order_num: "",
      };
      this.edit = false;
    },
    edit_project() {
      axios
        .put("/project/" + this.project._id, {
          project: this.project,
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Updated!",
            });
            this.$emit("project-updated");
          } else {
            this.$message({
              type: "error",
              message: "Update Failed!",
            });
          }
        })
        .catch(function (error) {
          alert(error);
        });
      this.hideModal();
    },
    add_new_project() {
      this.project.uid = this.$store.state.user._id;
      axios
        .post("/project/", {
          project: this.project,
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.$emit("project-updated");
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
          }
        })
        .catch(function (error) {
          alert(error);
        });
      this.hideModal();
    },
  },
};
</script>

<style scoped>
</style>